import { USER_SETTINGS_CHILDREN as COMMON_USER_SETTINGS_CHILDREN } from '@ids-products';
import { ILayoutItem } from '@microsec/interfaces';

export const USER_SETTINGS_CHILDREN: ILayoutItem[] = [...COMMON_USER_SETTINGS_CHILDREN];
